import * as swcHelpers from '@swc/helpers';

// We need to dynamically verify the address we get back from apple. A failing streetnumber is OK, since it can be contained in the first address line
// On all other validation errors, the payment should be aborted.
const mapApplePayContactAddress = (paymentContact)=>{
    var ref, ref1;
    return swcHelpers.objectSpread({
        firstName: paymentContact.givenName || '',
        lastName: paymentContact.familyName || '',
        streetName: ((ref = paymentContact.addressLines) === null || ref === void 0 ? void 0 : ref[0]) || '',
        streetNumber: ((ref1 = paymentContact.addressLines) === null || ref1 === void 0 ? void 0 : ref1[1]) || '',
        postalCode: (paymentContact === null || paymentContact === void 0 ? void 0 : paymentContact.postalCode) || '',
        city: (paymentContact === null || paymentContact === void 0 ? void 0 : paymentContact.locality) || '',
        countryCode: paymentContact.countryCode || ''
    }, paymentContact.phoneNumber ? {
        phone: paymentContact.phoneNumber
    } : {}, paymentContact.emailAddress ? {
        email: paymentContact.emailAddress
    } : {}, paymentContact.administrativeArea ? {
        region: paymentContact.administrativeArea
    } : {}, paymentContact.subAdministrativeArea ? {
        region: paymentContact.subAdministrativeArea
    } : {});
};

export { mapApplePayContactAddress };
//# sourceMappingURL=apple-pay-contact-address.js.map
